import moment from 'moment';

const futureDateValidator = (offset) => {
  // expected format is: 2020-01-03T02:01

  return (value) => {
    if(value) {
      let date = moment(value, 'YYYY-MM-DDTHH:mm:ss');
      let now = moment();
      let secondsDiff = date.diff(now, 'seconds');

      return secondsDiff > offset;
    } else {
      return false;
    }
  };
};

export {
  futureDateValidator,
}
